import { Layout } from 'antd';
import classNames from 'classnames';
import * as React from 'react';

import { ComponentWithChildrenProps } from '../../typings';

import styles from './MainLayoutHeader.module.less';

export interface MainLayoutHeaderProps extends ComponentWithChildrenProps {}

export function MainLayoutHeader({ className, style, children }: MainLayoutHeaderProps) {
  return (
    <Layout.Header className={classNames('contentWrapper', styles.mainLayoutHeader, className)} style={style}>
      <div className={styles.content}>{children}</div>
    </Layout.Header>
  );
}
